import styled, { css } from 'styled-components'
import { Text, Button, Flex } from 'vvs-uikit'

export const AddMoleButton = styled(Button)<{ rect?: boolean; isDark?: boolean }>`
  width: ${({ rect }) => (rect ? '126px' : '56px')};
  height: ${({ rect }) => (rect ? '261.5px' : '56px')};
  border-radius: 4px;
  border: ${({ rect }) => (rect ? '3px' : '1px')} ${({ isDark }) => (isDark ? 'white' : 'black')} dashed;
  box-shadow: none;
  align-items: center;
  justify-content: center;
  background: unset;

  :hover {
    text-decoration: none;
  }

  ${({ rect }) =>
    rect &&
    css`
      min-width: 126px;
      padding: 0;
    `}
`

export const EllipsisText = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const MoleAvatar = styled(Flex)<{ image?: string; size?: string; rounded?: boolean; pixelated?: boolean }>`
  width: ${({ size }) => size ?? '100%'};
  aspect-ratio: 1;
  background: ${({ image }) => `url('${image}')`};
  background-size: contain;
  border-radius: ${({ rounded }) => (rounded ? '4px' : '0')};
  position: relative;

  background-repeat: no-repeat;

  ${({ pixelated }) => pixelated && `image-rendering: pixelated;`}
`

export const MoleAvatarBottomBadgeWrapper = styled(Flex)`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 16px;
  flex-direction: column;
  align-items: center;
`

export const Carousel = styled(Flex)`
  padding-top: 10px;
  padding-right: 10px;
  display: flex;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
  }
  gap: 0.75rem;
  cursor: grab;
`
